var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.667 6.667H7c-.8 0-1.333.533-1.333 1.333v1.867l10.667 6L27 10V8c0-.8-.533-1.333-1.333-1.333Z",
    fill: "#10A8BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.667 18.533-10-5.6V24c0 .8.533 1.333 1.333 1.333h18.667c.8 0 1.333-.533 1.333-1.333V12.933l-10 5.6c-.373.187-.96.187-1.333 0Z",
    fill: "#10A8BA"
  })));
};
export default SvgMail;